const APPLE_PLATFORM_PATTERN = /Mac|iPhone|iPad|iPod/i;

// NOTE: "⌘K" on Apple platforms, "Ctrl+K" elsewhere — the key the palette's
// shortcut actually listens for on this machine.
export const getSearchShortcutLabel = (): string => {
  const platform =
    typeof navigator === "undefined"
      ? ""
      : `${navigator.platform} ${navigator.userAgent}`;
  return APPLE_PLATFORM_PATTERN.test(platform) ? "⌘K" : "Ctrl+K";
};
